<!--Banner part code-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel  uk-flex-center uk-flex-middle"
            style="background-image: url(../../assets/androidbanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top:20px ;">

                    <h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical">Android Application Development</h1>

                    <p class="uk-text-left uk-padding-large uk-padding-remove-vertical" style="font-size: 20px;">WebSoulLabs

                        is a rapidly growing android app development company, focused in delivering customer oriented,
                        applications that takes your business success.
                        
                       
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Banner part code ends-->


<!--Paragraph part code-->
<div class="uk-section uk-padding">
    <div class="uk-container">
        <br>
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Apps are now a conventional,
                 trusted way to deliver content and services. But in a crowded market, how does a mobile app
                  become useful, relevant, and valued so it enchant and retains users? Apps provide
                   opportunities to build around user needs and grow long-term and healthy relationships 
                   with loyal customers. Our inclusive range of custom Android app development services
                    boosts your business with advanced technology and affordable cost and helps you to
                     accomplish your goals.
            </p>
            <p class="uk-text-medium uk-text-justify"  style="font-size: 18px;">We perform an in-depth 
                market study and well-researched forecasts to substantiate your business idea and create
                 mobile strategies that meet your business needs. Our expert designers implement the best
                  design techniques to ensure the interactive UI designs that enhance the customer
                   satisfaction. Android app development is one of our fundamental strengths. Our expert
                    team of developers works hard to create inherent apps to help your business grow
                     exponentially.
            </p>
    </div> 
</div>
<!--Paragraph part code ends-->


<!--Column part code-->
<div class="uk-section uk-section-default">
    <div class="uk-container">
        <div class="uk-column-1-2@s">

            <h2 style="font-weight:600">Android App Development</h2>
            <p class="uk-text-medium uk-text-justify">The vast majority of the world's population
                 uses Android. The increase in Android users also paved the way for the development
                  of the app development company. The reason why WebSoulLabs is at the forefront of 
                  this kind of  android app development companies is because of the work of sincere 
                  and highly skilled employees. The trade secret to develop apps that lead to millions
                   of downloads from the Google Play Store is exclusively owned by our employees.
                    By using latest technology, coding processes and standards we develop mobile apps 
                    that are compatible with your android devices. So we assure you the best android
                     applications to accomplish your business goals. </p>
            <p class="uk-text-medium uk-text-justify"> <button class=" uk-button uk-button-primary">Know More</button> </p>




            <img data-src="assets/android.jpg" width="600" height="400" alt="pic" uk-img>

        </div>
        <div class="uk-column-1-2@s uk-margin-medium ">

            <img data-src="assets/mobilephone.jpg" width="600" height="600" alt="pic" uk-img>




            <h2 style="font-weight:600">The Best Android Applications</h2>
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">We develop customized,
                 robust and scalable android applications that help you to boost your business.
                  We provide you incredibly personalized android applications that renders endless
                   solutions to all your desires. Our experienced and dedicated team of developers
                    customize apps as per your requirements .We deliver custom-tailored and innovative 
                    solutions that delight customers. When you choose our android app development services
                     you will get an application that is feature enriched, secure and fully functional in 
                     reliance with your business requirement. 
            </p>
            <p class="uk-text-medium uk-text-justify"><button class=" uk-button uk-button-primary">Know More</button></p>

        </div>
    </div>
</div>
<!--Column part code ends-->


<!--Services part code-->
<div class="uk-container uk-container-expand">
    <div class="ws-services uk-grid-medium uk-child-width-1-3@s uk-flex-center uk-grid-match uk-light" uk-grid>


        <h1 class="uk-padding-small uk-align-center">Android App Development Services </h1>

        <div>
            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">

                    <img class="uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/dev.png"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>Custom Android App Development </strong></h3>
                <p class="uk-text-justify">Our android app development team creates tremendous apps which stand out from numerous 
                    apps in the digital market. We turn your valuable ideas into custom android applications
                    0 and incarnate the ever best outcomes for our clients.</p>

            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">

                    <img class="uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/chat.png"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>Social Networking and Chat Applications</strong></h3>
                <p class="uk-text-justify">Our wide ranging social networking and chat applications help you to expand your business,
                     enhance credibility and improves customer satisfaction. We have a powerful team of
                      professionals who deploy advanced technology, consistent support and prompt services. 
                </p>

            </div>
        </div>

        <div>
            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class="uk-border-circle uk-align-center" src="assets/centralization.jpg" width="70" height="70"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/rescue.jpg"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>Business Related <br>Applications </strong></h3>
                <p class="uk-text-justify">We offer high end business applications that simplify all your business processes and 
                    improve productivity. Our business application services are completely tailored to suit
                     your requirements. The strategic way in which we successfully execute our tasks.
                </p>

            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel">

                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class="uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/travels.png"
                        width="70" height="70" alt="border-circle">
                </div>
                <h3  style="margin-top: 0px;"><strong>Travel and Online Booking Apps </strong></h3>
                <p class="uk-text-justify">We develop travel and online booking applications incorporating the latest technology 
                    at an optimal price. Our team of highly skilled mobile app developers are proficient
                     in delivering visually appealing travel and online booking applications</p>

            </div>
        </div>


        <div>

            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class=" uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/shop.png"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>E-commerce & Shopping Apps </strong></h3>
                <p class="uk-text-justify">We develop e-commerce applications to mobilize your business. Our e-commerce apps pave
                     the way to online product catalog surfing which provides enhanced virtual shopping
                      experience. We fulfill customer requirements and feed clients with world-class
                       experience.
                </p>

            </div>
        </div>
        <div>

            <div class="uk-placeholder uk-text-center uk-panel uk-animation-fast uk-animation-fade">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class=" uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/music.jpg"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>Music and Entertainment Apps </strong></h3>
                <p class="uk-text-justify">Our music and entertainment application development team know what the clients need.
                     Our vibrant team of professionals is well-experienced and knowledgeable to understand
                      the ultimate needs of media and the entertainment.
                </p>

            </div>
        </div>
        <div>

            <div class="uk-placeholder uk-text-center uk-panel uk-animation-fast uk-animation-fade">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class=" uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/it.png"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>Multimedia and Enterprise Applications </strong></h3>
                <p class="uk-text-justify">We develop multimedia and enterprise applications to support the needs of your enterprise.
                     We have solutions that provide business logic and tools for business processes to improve
                      efficiency and better productivity.
                </p>

            </div>
        </div>
        <div>

            <div class="uk-placeholder uk-text-center uk-panel uk-animation-fast uk-animation-fade">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class=" uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/education.jpg"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>News and Educational Mobile Applications </strong></h3>
                <p class="uk-text-justify">WebSoulLabs has a great experience in developing news and educational mobile applications.
                     Our applications are helpful in understanding a new concept or subject quickly with
                      interactive multimedia.
                </p>

            </div>
        </div>
        <div>

            <div class="uk-placeholder uk-text-center uk-panel  uk-animation-fast uk-animation-fade">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class=" uk-border-circle uk-align-center" src="assets/centralization.jpg" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/image.png"
                        width="70" height="70" alt="">
                </div>
                <h3  style="margin-top: 0px;"><strong>Upgrade and Maintenance of Android Applications </strong></h3>
                <p class="uk-text-justify">We provide maintenance to keep your Android application up-to-date with changing user needs,
                    echnology and market challenges. We analyze the application, identify the bugs and resolve
                     them quickly to improve productivity.


                </p>

            </div>
        </div>
    </div>
</div>
<!--Services part code ends-->


<!--Related Services part code-->

       

<h1 class="uk-text-center"><span>Related Services</span></h1>
<br>
<div class="uk-container">
   
    <div class="uk-grid-small  uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
               
                <img class=" uk-align-center" src="assets/icons/ig1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">IPhone App<br> Development</h4>
        
            </div>
        </div>
       
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class="uk-border-pill uk-align-center" src="assets/icons/mobileg1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Mobile App<br> Development</h4>
            
            
            </div>
        </div>
      

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/gapg1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">PhoneGap App<br> Development</h4>
            </div>
        </div>

        <div>
       
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/xamaring10.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Xamarin App<br> Development</h4>

           
            </div>
        </div>

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/cross.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Cross Platform App Development</h4>

           
            </div>
        </div>

       
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium"  style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/swiftg9.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Swift App<br> Development</h4>

            </div>
        </div>
       
    </div>

</div>

<!--Related Services part code ends-->



<!--Technology stack part code-->
<br>
<h1 class="uk-text-center"><span>Technology Stack</span></h1>
<br>
<div class="uk-container">
    <div class=" wss  uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/swi.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Swift</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/and.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Android</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/java.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Java</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/apple.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Ios</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/kotlin.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Kotlin</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Fabric.jpg" width="85" height="85"
                    alt="border-circle">
                <h4 style="font-weight:600">Fabric</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/xamarin.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Xamarin</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/React.webp" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">React Js</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/appt.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Appcelerator <br>Titanium</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/flutter.png" width="80" height="80"
                    alt="border-circle">
                <h4 style="font-weight:600">Flutter</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/back.png" width="130" height="130"
                    alt="border-circle">
                <h4 style="font-weight:600">Backbone</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/ember.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Ember</h4>
            </div>
        </div>
    </div>
</div>
<br>
<!--Technology stack part code ends-->
